{
  "search": {
    "entry": "بحث",
    "title": "البحث السريع",
    "placeholder": "ابحث في {{scope}}",
    "placeholderAny": "ابحث",
    "scope": {
      "catalogue_items": "أصناف الكتالوج",
      "requests": "طلبات الشراء",
      "purchase_orders": "أوامر الشراء",
      "rfqs": "طلبات العروض",
      "suppliers": "الموردين",
      "orders": "أوامرك",
      "rfq_invitations": "طلبات العروض الموجهة إليك",
      "organisations": "المنشآت",
      "invoices": "فواتيرك"
    },
    "group": {
      "catalogue_items": "أصناف الكتالوج",
      "requests": "طلبات الشراء",
      "purchase_orders": "أوامر الشراء",
      "rfqs": "طلبات العروض",
      "suppliers": "الموردون",
      "orders": "أوامرك",
      "rfq_invitations": "طلبات العروض الموجهة إليك",
      "organisations": "المنشآت",
      "navigation": "الانتقال إلى",
      "help": "المساعدة",
      "invoices": "فواتيرك",
      "best": "أفضل تطابق",
      "recent": "عمليات البحث الأخيرة",
      "commands": "ابدأ"
    },
    "help": {
      "keywords": "مساعدة المساعدة دليل جولة جولات الجولات إرشاد إرشادية",
      "all": "كل المساعدة والجولات الإرشادية",
      "allHint": "يفتح المساعدة والجولات الإرشادية."
    },
    "seeAll": "عرض الكل في {{list}}",
    "results": "النتائج",
    "initial": "اكتب حرفين على الأقل، أو رقمًا.",
    "initialScope": "يبحث في {{scope}} مما يمكنك فتحه أصلًا. لا يتغير شيء.",
    "searching": "جارٍ البحث…",
    "noResults": "لا توجد نتائج تطابق «{{term}}»",
    "noResultsHint": "تحقّق من الكتابة، أو جرّب رقمًا أو رمزًا.",
    "failed": "تعذّر البحث",
    "failedHint": "هذه ليست نتيجة فارغة: لم يكتمل البحث. لم يتغير شيء.",
    "partial": "لم يُبحث فيها الآن: {{groups}}",
    "partialHint": "النتائج الأخرى أدناه كاملة.",
    "noneIn": "لا توجد نتائج في {{groups}}.",
    "clearInput": "مسح نص البحث",
    "close": "إغلاق البحث",
    "keys": {
      "label": "لوحة المفاتيح",
      "move": "للتنقل",
      "open": "للفتح",
      "close": "للإغلاق"
    },
    "announce": "النتائج المعروضة: {{count}}",
    "status": {
      "requests": {
        "draft": "مسودة",
        "pending_approval": "بانتظار الاعتماد",
        "approved": "معتمد",
        "returned": "مُعاد للتعديل",
        "rejected": "مرفوض",
        "cancelled": "ملغى",
        "procurement_review": "لدى المشتريات",
        "sourcing_required": "يتطلب توريداً",
        "procurement_processing": "قيد المعالجة لدى المشتريات",
        "po_created": "تم إنشاء أوامر الشراء"
      },
      "purchase_orders": {
        "draft": "مسودة",
        "issued": "صادر",
        "sent": "مُرسل للمورد",
        "active": "قيد التنفيذ",
        "completed": "مكتمل",
        "cancelled": "ملغى",
        "pending": "بانتظار رد المورد",
        "acknowledged": "مؤكَّد من المورد",
        "query": "استفسار من المورد",
        "partially_available": "متوفر جزئياً",
        "declined": "مرفوض من المورد"
      },
      "orders": {
        "issued": "صادر",
        "sent": "مُرسل للمورد",
        "active": "قيد التنفيذ",
        "completed": "مكتمل",
        "cancelled": "ملغى",
        "pending": "بانتظار رد المورد",
        "acknowledged": "مؤكَّد من المورد",
        "query": "استفسار من المورد",
        "partially_available": "متوفر جزئياً",
        "declined": "مرفوض من المورد"
      },
      "rfqs": {
        "draft": "مسودة",
        "open": "مفتوح",
        "awarded": "تمت الترسية",
        "no_award": "دون ترسية",
        "cancelled": "ملغى"
      },
      "rfq_invitations": {
        "invited": "مدعو",
        "responded": "قدّم عرضاً",
        "late": "متأخر",
        "incomplete": "غير مكتمل",
        "withdrawn": "منسحب",
        "non_responsive": "لم يرد"
      },
      "suppliers": {
        "draft": "مسودة",
        "active": "نشط",
        "suspended": "موقوف",
        "archived": "مؤرشف"
      },
      "organisations": {
        "provisioning": "قيد التهيئة",
        "active": "نشطة",
        "suspended": "موقوفة",
        "closed": "مغلقة"
      }
    },
    "seeAllFor": "ابحث في كل {{list}} عن «{{term}}»",
    "noneInByName": "لا يطابق رقم أو اسم في {{groups}}.",
    "tooMany": "عمليات بحث كثيرة في وقت قصير",
    "tooManyHint": "انتظر قليلًا ثم أعد المحاولة. لم يتغير شيء.",
    "announceMore": "يوجد المزيد في {{groups}}.",
    "moreAvailable": "والمزيد متاح",
    "shown_zero": "لا شيء معروض",
    "shown_one": "نتيجة واحدة معروضة",
    "shown_two": "نتيجتان معروضتان",
    "shown_few": "{{count}} نتائج معروضة",
    "shown_many": "{{count}} نتيجة معروضة",
    "shown_other": "{{count}} نتيجة معروضة",
    "commandHint": "يفتح النموذج. لا يُنشأ شيء حتى تحفظ هناك.",
    "recent": {
      "clear": "مسح عمليات البحث الأخيرة",
      "cleared": "تم مسح عمليات البحث الأخيرة."
    },
    "coach": {
      "kind": "مسار عمل موجَّه",
      "start": "ابدأ",
      "continue": "تابع من الخطوة {{step}} من {{total}}",
      "running": "يعمل الآن: اعرضه",
      "completed": "مكتمل: ابدأ من جديد"
    },
    "shell": {
      "waiting_zero": "لا شيء بانتظارك",
      "waiting_one": "عنصر واحد بانتظارك",
      "waiting_two": "عنصران بانتظارك",
      "waiting_few": "{{count}} عناصر بانتظارك",
      "waiting_many": "{{count}} عنصرًا بانتظارك",
      "waiting_other": "{{count}} عنصر بانتظارك"
    }
  },
  "shared": {
    "state": {
      "noAccessTitle": "غير متاح بصلاحياتك",
      "noAccessBody": "لا يشمل دورك هذا الجزء. إذا كان عملك يتطلبه، فاطلبه من مدير النظام.",
      "notFoundTitle": "تعذّر العثور على هذا السجل",
      "notFoundBody": "قد يكون الرابط قديمًا، أو قد لا يكون السجل مما يمكنك فتحه.",
      "loadFailedTitle": "تعذّر تحميل هذه الصفحة",
      "goTo": "الانتقال إلى {{place}}",
      "filterTitle": "تعذّر تطبيق أحد عوامل التصفية في هذا الرابط",
      "filterBody": "يشير إلى شيء لم يعد موجودًا، أو يقع خارج ما يمكنك الاطلاع عليه. اختر «مسح الكل» لعرض القائمة كاملة."
    },
    "list": {
      "resultCount": "عدد النتائج: {{count}}"
    }
  }
}
